"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _CartStore = require("../../stores/CartStore");

var _CartStore2 = _interopRequireDefault(_CartStore);

var _Utility = require("../../utils/Utility");

var Utils = _interopRequireWildcard(_Utility);

var _Header = require("./Header");

var _Header2 = _interopRequireDefault(_Header);

var _Footer = require("./Footer");

var _Footer2 = _interopRequireDefault(_Footer);

var _reactRouterDom = require("react-router-dom");

var _OrderSuccessScreen = require("./OrderSuccessScreen");

var _OrderSuccessScreen2 = _interopRequireDefault(_OrderSuccessScreen);

var _MainStore = require("../../stores/MainStore");

var _MainStore2 = _interopRequireDefault(_MainStore);

var _Spinner = require("../generic/Spinner");

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//wrapper functional component to pass params as props to main file.
function withOrderSuccessRouter(Component) {
    function ComponentWithOrderSuccessRouter(props) {
        var history = (0, _reactRouterDom.useHistory)();
        var params = (0, _reactRouterDom.useParams)();
        return _react2.default.createElement(Component, _extends({}, props, { history: history, params: params /* other hooks */ }, {
            params: params

        }));
    }
    return ComponentWithOrderSuccessRouter;
}

var OrderSuccessMain = function (_React$Component) {
    _inherits(OrderSuccessMain, _React$Component);

    function OrderSuccessMain(props) {
        _classCallCheck(this, OrderSuccessMain);

        var _this = _possibleConstructorReturn(this, (OrderSuccessMain.__proto__ || Object.getPrototypeOf(OrderSuccessMain)).call(this, props));

        _this.state = {
            orders: {},
            isLoading: false,
            cartOrderDetail: {},
            showSpinner: true,
            view: {
                orderDetail: false
            }
        };

        return _this;
    }

    _createClass(OrderSuccessMain, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            var orderDetail = _CartStore2.default.getCartOrderDetailsObj();

            setTimeout(function () {
                if (!Utils.isEmptyObj(orderDetail)) {
                    _this2.setState({
                        cartOrderDetail: orderDetail,
                        isLoading: false,
                        messageString: "",
                        showSpinner: false
                    });
                } else {
                    _this2.setState({
                        showSpinner: false
                    });
                    var history = _this2.props.history;

                    var locId = _this2.props.params.locId;
                    history.push({
                        pathname: "/location/" + locId,
                        resetStore: false
                    });
                }
            }, 1000);

            //scroll to top
            window.scrollTo(0, 0);
        }
    }, {
        key: "renderItemsDetail",
        value: function renderItemsDetail() {
            var order = this.state.cartOrderDetail;
            var itemDetail = order.orderDetail.items;

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                itemDetail.map(function (el, index) {
                    return _react2.default.createElement(
                        "tr",
                        { key: "id" + index },
                        _react2.default.createElement(
                            "td",
                            null,
                            el.itemName
                        ),
                        _react2.default.createElement(
                            "td",
                            { className: "text-right" },
                            el.itemQty
                        ),
                        _react2.default.createElement(
                            "td",
                            { className: "text-right" },
                            "$",
                            el.itemPrice
                        )
                    );
                })
            );
        }
    }, {
        key: "loadSpinner",
        value: function loadSpinner() {
            return _react2.default.createElement(_Spinner2.default, {
                disply: "block",
                classNames: "spinner-box"
            });
        }
    }, {
        key: "loadMainContent",
        value: function loadMainContent() {
            var locObj = _MainStore2.default.getActiveLocation();
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_Header2.default, null),
                _react2.default.createElement(_OrderSuccessScreen2.default, {
                    locationDetail: locObj,
                    order: this.state.cartOrderDetail,
                    locId: this.props.params.locId,
                    history: this.props.history
                }),
                _react2.default.createElement(_Footer2.default, null)
            );
        }
    }, {
        key: "render",
        value: function render() {
            var order = this.state.cartOrderDetail;
            // console.log(order.orderDetail.userInfo.name)

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                this.state.showSpinner ? this.loadSpinner() : this.loadMainContent()
            );
        }
    }]);

    return OrderSuccessMain;
}(_react2.default.Component);

//create highter order component.


var HOC_ORDER_SUCCESS = withOrderSuccessRouter(OrderSuccessMain);
exports.default = HOC_ORDER_SUCCESS;


//////////////////
// WEBPACK FOOTER
// ./src/components/common/OrderSuccessMain.jsx
// module id = 737
// module chunks = 0